import React from 'react';
import PropTypes from 'prop-types';
import { I18N } from 'commons';
import { Button } from 'reactstrap';
import FieldSection from 'components/forms/FieldSection';

const LatitudeAndLongitude = ({
  values,
  touched,
  errors,
  showlatitudeAndLongitude,
  showLatitudeAndLongitudeHelpContent,
  hideLatitudeAndLongitudeHelpContent,
  readOnly
}) => (
  <div className="form-group ml-0 mr-0">
    {!showlatitudeAndLongitude && (
      <a
        href="JavaScript:void(0);"
        onClick={showLatitudeAndLongitudeHelpContent}
        eb-test="ssp_location_link_show_LatitudeAndLongitude"
      >
        <I18N>ssp.address.latitude&longitude.show</I18N>
      </a>
    )}
    {showlatitudeAndLongitude && (
      <a
        href="JavaScript:void(0);"
        onClick={hideLatitudeAndLongitudeHelpContent}
        eb-test="ssp_location_link_hide_LatitudeAndLongitude"
      >
        <I18N>ssp.address.latitude&longitude.hide</I18N>
      </a>
    )}
    {showlatitudeAndLongitude && (
      <div className="row">
        <p className="form-text col-md-12">
          <I18N>ssp.address.latitude&longitude.help</I18N>
        </p>
        <FieldSection
          className="col-md-6"
          name="lat"
          title="ssp.address.latitude"
          maxLength="75"
          readOnly={readOnly}
          isOptional={true}
          {...{ values, touched, errors }}
        />
        <FieldSection
          className="col-md-6"
          name="lon"
          title="ssp.address.longitude"
          maxLength="75"
          readOnly={readOnly}
          isOptional={true}
          {...{ values, touched, errors }}
        />
      </div>
    )}
  </div>
);

LatitudeAndLongitude.propTypes = {
  values: PropTypes.shape().isRequired,
  touched: PropTypes.shape().isRequired,
  errors: PropTypes.shape().isRequired,
  showlatitudeAndLongitude: PropTypes.bool.isRequired,
  showLatitudeAndLongitudeHelpContent: PropTypes.func.isRequired,
  hideLatitudeAndLongitudeHelpContent: PropTypes.func.isRequired,
  readOnly: PropTypes.bool.isRequired,
};

export default LatitudeAndLongitude;
